<!-- 政策解读 -->
<template>
  <div class="inter">
    <van-tabs v-model="activeName" @click="onClick">
      <van-tab
        :title="item.name"
        :name="item.channel_id"
        v-for="(item, index) in items"
        :key="index"
      >
        <Item :index="index" :id="id" :name="name" />
      </van-tab>
    </van-tabs>
    <div class="backs" @click="back">
      <img src="@/assets/img/home/toBack.png"/>
    </div>
  </div>
</template>

<script>
import Item from "./items";
import { getKinds } from "@/api/apiData";
import { Toast } from "vant";
export default {
  components: { Item },
  data() {
    return {
      items: [],
      activeName: "0",
      id: "",
      name: ""
    };
  },
  computed: {},
  methods: {
    back() {
      this.$router.back();
    },
    // 获取栏目分类
    getLanKinds() {
      var that = this;
      getKinds({ parent_id: 2 }).then(res => {
        // //(res);
        if (res.code == 1) {
          that.items = res.data;
          that.id = res.data[0].channel_id;
          that.name = res.data[0].name;
        } else {
          Toast(res.msg);
        }
      });
    },
    onClick(name, title) {
      var that = this;
      that.id = name;
      that.name = title;
    }
  },
  created() {},
  mounted() {
    this.getLanKinds();
  }
};
</script>
<style lang='less' scoped>
/deep/.van-tabs__content::before {
  content: "";
  display: block;
  height: 0.8rem;
  width: 100%;
}
/deep/.van-tabs__wrap {
  height: 0.8rem;
  position: fixed;
  width: 100%;
  background: #fff;
  z-index: 100;
}

/deep/.van-tabs__nav--line {
  border-bottom: 0.01rem solid #ebedf0;
  padding-bottom: 0;
  .van-tab {
    font-size: 0.28rem;
    font-weight: 400;
    line-height: 0.4rem;
    color: rgba(128, 128, 128, 1);
  }
  .van-tab--active {
    font-size: 0.33rem;
    font-weight: bold;
    line-height: 0.5rem;
    color: rgba(51, 51, 51, 1);
  }
  .van-tabs__line {
    bottom: 0;
    width: 0.5rem !important;
    background: #ff4343;
    height: 0.03rem;
  }
}
.inter {
  padding: 0 0.32rem;
}
.backs {
  position: fixed;
  bottom: 5%;
  right: 5%;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  box-shadow: 0 0 0.05rem 0.01rem rgba(21, 21, 21, 0.3);
  z-index: 10;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 0.5rem;
    height: 0.5rem;
  }
}
</style>